import React, { useEffect, useState } from "react";
import { trans } from "utils/helpers";
import { Button } from "components/Button/Button";
import { Textbox } from "components/Textbox/Textbox";
import { SimpleGrid } from "../SimpleGrid/SimpleGrid";
import { postGridForm } from "./api";
import { getDynamicDataGridApi } from "../../api";
import { Loading } from "components/Loading/loading";
import { InputTypes } from "types/enum";

interface DataGridFormProps {
  mode: "create" | "edit" | "view";
  onHide: () => void;
  realod?: () => void;
  DynamicObj?: any;
}

export const DataGridForm: React.FC<DataGridFormProps> = ({
  mode,
  realod,
  onHide,
  DynamicObj,
}) => {
  const [formData, setFormData] = useState<any>({
    tbodyLength: 3,
    name: "",
    theadLength: 3,
  });
  const [dataGridFields, setDataGridFields] = useState([]);
  const [response, setResponse] = useState<any>();
  const [loading, setLoading] = useState(false);
  const handleDataGridFields = (data: any) => {
    setDataGridFields(() =>
      data.map((item) => {
        return { ...item, ref: undefined };
      })
    );
  };


  async function getDynamicDataGridAsync() {
    setLoading(false);
    try {
      const res = await getDynamicDataGridApi(DynamicObj.KeyId);

   if(JSON.parse(res.DataGridFields)?.inputList?.[0]){
  setResponse({
        ...res,
        theadLength: JSON.parse(res.DataGridFields)?.inputList?JSON.parse(res.DataGridFields)?.inputList?.[0]?.inputList?.length:JSON.parse(res.DataGridFields)?.inputList?.[0]?.length,
        theadData: JSON.parse(res.DataGridFields)?.inputList?JSON.parse(res.DataGridFields)?.inputList?.[0]?.inputList:JSON.parse(res.DataGridFields)?.[0]?.inputList,
      });
   }else{

    
  setResponse({
        ...res,
        theadLength: JSON.parse(res.DataGridFields)?.inputList?JSON.parse(res.DataGridFields)?.inputList?.inputList?.length:JSON.parse(res.DataGridFields)?.inputList?.length,
        theadData: JSON.parse(res.DataGridFields)?.inputList?JSON.parse(res.DataGridFields)?.inputList?.inputList:JSON.parse(res.DataGridFields)?.inputList,
      });
   }
   
    } catch (err: any) {}
    setLoading(true);
  }



  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Handle form submission
    let DataGridObject: any = {};
    let objectLabels: any = {};
    dataGridFields.map((item: any) => {
      objectLabels = { ...objectLabels, [item.SystemKey]: item.title };
      if (item.typeName == "Position" || item.typeName == "Person"|| item.backendType == "guid") {
        DataGridObject[item.SystemKey + "Description"] = "string";
      }
      if (item.type == InputTypes.DynamicDictionary) {
        DataGridObject[item.SystemKey + "Description"] = "string";
      }
      
      DataGridObject[item.SystemKey] = item.backendType
      delete item.icon
    })
   let data =  {
      "SystemKey": formData.SystemKey,
      "Title": formData.Title,
      "TitleEN": formData.TitleEN,
      "DataGridObject":JSON.stringify(DataGridObject) ,
      "DataGridFields": JSON.stringify({inputList:dataGridFields}),
      "DataGridLables": JSON.stringify(objectLabels),
      "Priority": formData.Priority
    }


  try {
    mode == "create"
      ? await postGridForm({inputList:[{...data}]}, "post")
      : await postGridForm({inputList:[{...data,Id:DynamicObj.KeyId}]}, "put");

    realod && realod();
  } catch (error) {}
  onHide();
  };

  useEffect(() => {
    if (mode == "edit") {
      getDynamicDataGridAsync();
    } else {
      setLoading(true);
    }
  }, [mode]);
  useEffect(() => {
    if (response) {
      setFormData({
        SystemKey: response.SystemKey,
        Title: response.Title,
        TitleEN: response.TitleEN,
        DataGridObject: JSON.parse(response.DataGridObject),
        DataGridFields: JSON.parse(response.DataGridFields)?.inputList?JSON.parse(response.DataGridFields)?.inputList:JSON.parse(response.DataGridFields),
        DataGridLables: JSON.parse(response.DataGridLables),
        Priority: response.Priority,
        theadLength:JSON.parse(response.DataGridFields)?.inputList? JSON.parse(response.DataGridFields)?.inputList?.length:JSON.parse(response.DataGridFields)?.length,
        theadData: JSON.parse(response.DataGridFields)?.inputList?JSON.parse(response.DataGridFields)?.inputList:JSON.parse(response.DataGridFields),
      });
    }
  }, [response]);

  return (
    <div className="data-grid-form">
      {loading ? (
        <form id="DataGridForm" onSubmit={handleSubmit}>
          <div className="card ">
            <div className="card-body row">
              <div className="col-4">
                <Textbox
                  textboxType="text"
                  textboxName="Title"
                  labelText={"Title"}
                  defaultValue={response?.Title}
                  onChange={(e) =>
                    setFormData({ ...formData, Title: e.target.value })
                  }
                />
              </div>
              <div className="col-2">
                <Textbox
                  textboxType="number"
                  min={1}
                  textboxName="theadLength"
                  labelText={trans("columns")} 
                  defaultValue={response?.theadLength || 3}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      theadLength: parseInt(e.target.value),
                    })
                  }
                />
              </div>
             <div className="col-2">
                <Textbox
                  textboxType="number"
                  textboxName="Priority"
                  labelText={"Priority"}
                  defaultValue={response?.Priority}
                  onChange={(e) =>
                    setFormData({ ...formData, Priority: e.target.value })
                  }
                />
              </div>
              <div className="col-4">
                <Textbox
                  required
                  textboxType="systemKey"
                  textboxName="SystemKey"
                  labelText={"SystemKey"}
                  defaultValue={response?.SystemKey}
                  onChange={(e) =>
                    setFormData({ ...formData, SystemKey: e.target.value })
                  }
                />
              </div>
            </div>
          </div>

          <div className="mt-4">
            <SimpleGrid
              showSetting={true}
              theadLength={formData.theadLength}
              tbodyLength={formData.tbodyLength}
              mode={"create"}
              handleDataGridFields={handleDataGridFields}
              theadData={response?.theadData || []}
              tbodyData={[]}
            createTableInDataCollectionTab={true}
            />
          </div>

          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button btnType="cancel" value={trans("cancel")} onClick={onHide} />
            <Button
              form="DataGridForm"
              btnType="submit"
              value={trans("save")}
            />
          </div>
        </form>
      ) : (
        <Loading />
      )}
    </div>
  );
};
